var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map"},[_c('div',{ref:"map",staticClass:"map-dom"}),_c('div',{staticClass:"input"},[_c('input',{attrs:{"id":"refInput","type":"text","placeholder":"请输入地址"}}),(_vm.cover)?_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.onClear}},[_vm._v("重新绘制")]):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }